import React, { useEffect } from 'react';
import { headers, baseUrl } from './common/credentials';


const port = "10003";
  

  export const getpofinancetrackerlistFromServer = (prminputs) => {
    let url = baseUrl + port + "/po_process/finance_prf_list/";
    return ([headers, url]); 
  }

  export const getpofinancetrackerbyidFromServer = (prminputs) => {
    let url = baseUrl + port + "/po_process/finance_prf_input_fields/";
    return ([headers, url]); 
  }

  export const getpofinancetrackerbyidFromServer1 = (prminputs) => {
    let url = baseUrl + port + "/po_process/user_prf_input_fields/";
    return ([headers, url]); 
  }

  export const postapprovalPRFFromServer = (prminputs) => {
    let url = baseUrl + port + "/po_process/finance_functionality/";
    return ([headers, url]); 
  }

  export const getoverallFromServer = (prminputs) => {
    let url = baseUrl + port + "/po_process/admin_list/";
    return ([headers, url]); 
  }

  export const getReportListFromServer = (prminputs) => {
    let url = baseUrl + port + "/po_process/report_list/";
    return ([headers, url]); 
  }

  

 